import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleOpenedSidebar } from '@reducers/menuSidebar/menuSidebarRequests';
import { menuSidebarSelector } from '@reducers/menuSidebar/menuSidebarSlice';
import Icon from '@atoms/Icon/Icon';
import menuSidebarConfig from '../../../config/menuSidebarLinks';

import {
  Container,
  Logo,
  Options,
  Option,
  IconContainer,
  HeaderTitle,
  Line,
  Sidebar,
  ChildOption,
  CollapseNavbar,
  ContentOptions,
  ContentSubOptions,
} from './styles.js';

import IconQueima from '@icons/IconQueima';

const Navbar = ({ history }) => {
  const dispatch = useDispatch();
  const { openedSidebar } = useSelector(menuSidebarSelector);
  const [activeSubmenu, setActiveSubmenu] = useState([]);

  const logout = () => {
    localStorage.clear();
    window.location.pathname = '/account/login';
  };

  const handleToogleMenuSidebar = () => {
    if (activeSubmenu.length && openedSidebar) {
      setActiveSubmenu([]);
      window.setTimeout(
        () => dispatch(toggleOpenedSidebar(!openedSidebar)),
        220
      );
    } else {
      dispatch(toggleOpenedSidebar(!openedSidebar));
    }
  };

  const handleToogleMenuContent = (item, { target }, to) => {
    if (to || target.tagName === 'A' || !openedSidebar) {
      if (to) {
        history.push(to);
      }

      return;
    }

    if (activeSubmenu.includes(item)) {
      setActiveSubmenu(prevArr => [
        ...prevArr.filter(menuItem => menuItem !== item),
      ]);
    } else {
      setActiveSubmenu(prevArr => [...prevArr, ...[item]]);
    }
  };

  useEffect(() => {
    menuSidebarConfig.forEach(menuContent => {
      if (
        menuContent.childs &&
        menuContent.childs.filter(
          menuChild => menuChild.link === window.location.pathname
        ).length > 0 &&
        !activeSubmenu.includes(menuContent.id)
      ) {
        setActiveSubmenu(prevArr => [...prevArr, ...[menuContent.id]]);
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Logo to="/home">
        <IconContainer>
          <IconQueima />
        </IconContainer>
        <Line />
        <HeaderTitle>Queima Admin</HeaderTitle>
      </Logo>
      <Sidebar open={openedSidebar}>
        <CollapseNavbar onClick={handleToogleMenuSidebar}>
          <Icon
            {...{
              name: 'ArrowLeft',
              color: '#302D44',
              width: 24,
              height: 24,
            }}
          />
        </CollapseNavbar>
        <ContentOptions>
          {menuSidebarConfig &&
            menuSidebarConfig.length &&
            menuSidebarConfig
              .filter(menuContent => menuContent.active)
              .map(menuContent => (
                <ChildOption
                  key={menuContent.id}
                  active={activeSubmenu.includes(menuContent.id)}
                  onClick={e =>
                    handleToogleMenuContent(menuContent.id, e, menuContent.link)
                  }
                  childs={menuContent.childs && menuContent.childs.length}
                >
                  <Icon
                    {...{
                      name: menuContent.id,
                      color: '#302D44',
                      width: 24,
                      height: 24,
                    }}
                  />
                  <span>{menuContent.label}</span>
                  {menuContent.childs && menuContent.childs.length && (
                    <ContentSubOptions>
                      {menuContent.childs &&
                        menuContent.childs.length &&
                        menuContent.childs.map(childContent => (
                          <Option key={childContent.id} to={childContent.link}>
                            {childContent.label}
                          </Option>
                        ))}
                    </ContentSubOptions>
                  )}
                </ChildOption>
              ))}
        </ContentOptions>
        <Options>
          <Option to="" onClick={logout}>
            Sair
          </Option>
        </Options>
      </Sidebar>
    </Container>
  );
};

export default withRouter(Navbar);
